/**
 * 数据总线，用于组件间通信
 * 目前用于插入菜单点击模板入口后，传递模板 id 给组件，创建 builder
 */
class DataBus {
    private data: any;

    setData(data: any) {
        this.data = data;
    }

    getData(isDeleteAfterGet = true) {
        const data = this.data;
        if (isDeleteAfterGet) {
            this.data = undefined;
        }
        return data;
    }
}

export const dataBus = new DataBus();
